module.exports = __webpack_public_path__ + "static/img/computer3.8dce1f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-images/computer3.jpg
// module id = 4Jwv
// module chunks = 0